export const SET_ACTIVE_FET_CHART = 'SET_ACTIVE_FET_CHART';
export const SET_FET_LIST = 'SET_FET_LIST';
export const UPDATE_FET_LIST = 'UPDATE_FET_LIST';
